import React from "react";

const ContactInfo = () => {
  const contactContent = [
    {
      id: 1,
      title: "Call Us 24/7",
      action: "tel:+96893579571",
      text: "+(968) 93579571",
      icon: "icon-phone",
    },
    {
      id: 2,
      title: "Email Support",
      action: "mailto:info@silverjarz.com",
      text: "info@silverjarz.com",
      icon: "icon-email",
    },
  ];

  return (
    <div className="d-flex flex-column y-gap-18">
      {contactContent.map((item) => (
        <div key={item.id} className="footer-contact-item">
          <span className="footer-contact-icon">
            <i className={item.icon} />
          </span>
          <div className="text-14">
            <div className="text-white-50 text-12">{item.title}</div>
            <a href={item.action} className="text-15 fw-500 hover-gold" style={{ color: "#ffffff" }}>
              {item.text}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactInfo;